import { FC } from 'react';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon';
import { Label } from '../Label/Label';

const CheckboxElement = styled.div<ICommonProps>`
  display: flex;
  align-items: center;
  .check {
    background-color: ${({ theme, checked }) => (checked ? theme.vars.newColor.blue1 : theme.vars.newColor.white)};
    border: 1px solid
      ${({ theme, checked }) => (checked ? `${theme.vars.newColor.blue1} !important` : theme.vars.newColor.darkGS3)};
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    margin-right: 5px;
    transition: background-color 0.2s ease-in-out;
    flex-shrink: 0;
    :hover {
      border: 1px solid ${({ theme }) => theme.vars.newColor.blue2};
    }
    &.disabled {
      background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
      border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
      input {
        cursor: default;
      }
    }
    input {
      position: absolute;
      width: 100%;
      height: 100%;
      margin: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
`;

interface ICommonProps {
  /** Is the checkbox checked */
  checked?: boolean;
}

export interface ICheckboxProps extends ICommonProps, IntrinsicProps {
  /** The id of the checkbox */
  id?: string;
  /** The label name for the checkbox */
  label?: string;
  /** Is the checkbox disabled */
  disabled?: boolean;
  /** The tabIndex of the checkbox */
  tabIndex?: number;
  /** onChange invoked whenever the checkbox is checked */
  onChange: (checked?: boolean) => void;
}

export const Checkbox: FC<ICheckboxProps> = ({ onChange, checked, id, disabled, ...props }) => {
  const handleChange = e => {
    onChange(e.target.checked);
  };

  return (
    <CheckboxElement checked={checked} onClick={handleChange}>
      <div className={`check ${disabled ? 'disabled' : ''}`}>
        <input
          data-testid="CheckboxElement"
          id={id}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={handleChange}
          {...props}
        />
        {checked && <Icon icon="check" color="#fff" />}
      </div>

      <Label name={props.label} for={id} variation="form" disabled={disabled} />
    </CheckboxElement>
  );
};
